function addDaysToDate(dt: Date,day:number): Date {
    dt.setTime(dt.getTime() + (day * 24 * 60 * 60 * 1000));
    return dt;
}

export default addDaysToDate;